import React from 'react'

// Icon
import WeekPagination from '../WeekPagination'

const ScheduleBox = () => {
  return (
    <section className='schedule_box1'>
      <h2>2023 Team Schedule:</h2>
      <WeekPagination />
    </section>
  )
}

export default ScheduleBox
